import { Box, Typography } from '@mui/material';

import { MuiStyledInput } from '../../../../shared/muiControls';

const Step2 = ({ handleFileName = () => null, isDoingAjax, inError = [] }) => {
    return (
        <Box
            sx={(theme) => {
                return {
                    mb: theme.spacing(15),
                };
            }}
        >
            <Typography
                sx={(theme) => {
                    return {
                        mb: theme.spacing(5),
                    };
                }}
            >
                Enter the name of the file and then click{' '}
                <Box
                    component="b"
                    sx={{ color: (theme) => theme.palette.primary.main }}
                >
                    Generate Invoices
                </Box>{' '}
                to create the invoices and download the file.
            </Typography>

            <MuiStyledInput
                onChange={(event) => handleFileName(event.target.value)}
                label="File Name:"
                id="file-name"
                disabled={isDoingAjax}
                sx={{
                    '& input': {
                        height: 'auto',
                    },
                }}
                textFieldSxObj={(theme) => {
                    return {
                        width: '20rem',
                        [theme.breakpoints.down('xl')]: {
                            width: '20rem',
                        },
                        [theme.breakpoints.down('lg')]: {
                            width: '20rem',
                        },
                    };
                }}
                error={inError?.find?.((err) => err?.id === 'file-name') !== undefined}
                errorMessage={inError?.find?.((err) => err?.id === 'file-name')?.errorMessage || null}
            />
        </Box>
    );
};

export default Step2;
